import { DefineOwnModule } from 'stores/type';
import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = {
  workspaceBox: {
    width: -1,
    height: -1,
  },
  libraryBox: {
    width: -1,
    height: -1,
    margin: -1,
  },
};

const storeModule: DefineOwnModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    workspaceBoxDimensions: (state) => state.workspaceBox,
    libraryBoxDimensions: (state) => state.libraryBox,
    libraryBoxMargin: (state) => state.libraryBox.margin,
  },

  actions: {
    dimensionsLibraryBox({ commit }, dimensions) {
      commit('DIMENSIONS_LIBRARY_BOX', dimensions);
    },
    dimensionsWorkspaceBox({ commit }, dimensions) {
      commit('DIMENSIONS_WORKSPACE_BOX', dimensions);
    },
  },

  mutations: {
    DIMENSIONS_LIBRARY_BOX(state, { width, height, margin }) {
      state.libraryBox.width = width;
      state.libraryBox.height = height;
      state.libraryBox.margin = margin;
    },
    DIMENSIONS_WORKSPACE_BOX(state, { width, height }) {
      state.workspaceBox.width = width;
      state.workspaceBox.height = height;
    },
  },
};

export default storeModule;
